import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { IUser } from 'src/app/core/models/user.model';
import { TranslateService } from '@ngx-translate/core';
/**
 * @ignore
 */
@Injectable({
  providedIn: 'root'
})
export class UtilService {

  secretKey = "wJANI1KEGhIVPFO6SU82Odle8dOHniKH";
  constructor(private translate: TranslateService) { }

  encrypt(data: string, key: string = this.secretKey): string {
    return CryptoJS.AES.encrypt(data, key).toString();
  }

  decrypt(data: string, key: string = this.secretKey) {
    try {
      return CryptoJS.AES.decrypt(data, key).toString(CryptoJS.enc.Utf8);
    }
    catch (err) {
      return data;
    }
  }

  /**
   * Checks user online status
   * @param users 
   */
  checkStatus(users: IUser[]) {
    users.forEach(user => {
      const tzoffset = -120 * 60000; // offset in milliseconds
      const localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);

      const localOffset = new Date().getTimezoneOffset() * 60 * 1000;

      const serverTime = (new Date(user.lastTimeOnline).getTime() + localOffset);

      const localTime = (new Date(localISOTime)).getTime();

      const difference = Math.abs(localTime - serverTime);

      const sec = difference / 1000;
      const min = difference / (1000 * 60);
      const hours = difference / (1000 * 60 * 60);
      const days = difference / (1000 * 60 * 60 * 24);
      const week = difference / (1000 * 60 * 60 * 24 * 7);
      const month = difference / (1000 * 60 * 60 * 24 * 30);
      const year = difference / (1000 * 60 * 60 * 24 * 365);

      if (year > 1) {
        this.translate.get('time.yearAgo').subscribe((s: string) => {
          user.online = s;
        });
      } else if (year < 1 && month > 1) {
        const months = Math.round(month)
        if (months === 1) {
          this.translate.get('time.monthAgo', { output: months }).subscribe((s: string) => {
            user.online = s;
          });
        } else {
          this.translate.get('time.monthsAgo', { output: months }).subscribe((s: string) => {
            user.online = s;
          });
        }
        // months == 1 ? user.online = `${months} month ago` : user.online = `${months} months ago`
      } else if (month < 1 && days > 1) {
        const day = Math.round(days);
        if (day === 1) {
          this.translate.get('time.dayAgo', { output: day }).subscribe((s: string) => {
            user.online = s;
          });
        } else {
          this.translate.get('time.daysAgo', { output: day }).subscribe((s: string) => {
            user.online = s;
          });
        }
        // day == 1 ? user.online = `${day} day ago` : user.online = `${day} days ago`
      } else if (days < 1 && hours > 1) {
        const hour = Math.round(hours);
        if (hour === 1) {
          this.translate.get('time.hourAgo', { output: hour }).subscribe((s: string) => {
            user.online = s;
          });
        } else {
          this.translate.get('time.hoursAgo', { output: hour }).subscribe((s: string) => {
            user.online = s;
          });
        }
        // hour == 1 ? user.online = `${hour} hour ago` : user.online = `${hour} hours ago`
        user.onlineColor = 'var(--clr-red)';
      } else if (hours < 1 && min > 6) {
        const minute = Math.round(min);
        user.onlineColor = 'var(--clr-yellow)';
        this.translate.get('time.minutesAgo', { output: minute }).subscribe((s: string) => {
          user.online = s;
        });
      } else {
        user.online = `online`;
        user.onlineColor = 'var(--clr-green)';
      }
    });
  }
}